import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import type { FlightResultsPageSearch } from '@/lib/schemas/flight-results-search.schema'

interface FlightSearchStoreActions {
  setLastFlightResults: (params: FlightResultsPageSearch, route: string) => void
}

interface FlightSearchStoreState {
  lastFlightResultsParams: FlightResultsPageSearch | null
  lastFlightResultsRoute: null | string
}

export const useFlightSearchStore = create<FlightSearchStoreActions & FlightSearchStoreState>()(
  persist(
    (set) => ({
      lastFlightResultsParams: null,
      lastFlightResultsRoute: null,
      setLastFlightResults: (params, route) => {
        set({ lastFlightResultsParams: params, lastFlightResultsRoute: route })
      },
    }),
    {
      name: 'flight-search',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
